// extracted by mini-css-extract-plugin
module.exports = {"title":"PlReturnComplaint_title__ZbvtC","navigation":"PlReturnComplaint_navigation__Z71HB"};